import { BonusStatusEnums } from 'config/types/bonus'
import { ValidatedBonusStatusEnums } from 'views/BonusCenter/hooks'

const path = '/images/bonus'

export enum DepositTimeEnums {
  First = 0,
  Second = 1,
  Third = 2,
  Fourth = 3,
}

export const ShortcutDepositTime = {
  [DepositTimeEnums.First]: '1st',
  [DepositTimeEnums.Second]: '2nd',
  [DepositTimeEnums.Third]: '3rd',
  [DepositTimeEnums.Fourth]: '4th',
}

export const DepositBonusAssetMap: Record<string, string[]> = {
  [DepositTimeEnums.First]: [`${path}/ftd-level-1.png`, `${path}/ftd-level-1-mobile.png`],
  [DepositTimeEnums.Second]: [`${path}/ftd-level-2.png`, `${path}/ftd-level-2-mobile.png`],
  [DepositTimeEnums.Third]: [`${path}/ftd-level-3.png`, `${path}/ftd-level-3-mobile.png`],
  [DepositTimeEnums.Fourth]: [`${path}/ftd-level-4.png`, `${path}/ftd-level-4-mobile.png`],
}


export const ValidBonusStatus = [BonusStatusEnums.Available, BonusStatusEnums.Active]
export const UsedBonusStatus = [ValidatedBonusStatusEnums.Claimed, ValidatedBonusStatusEnums.Used]
export const InvalidBonusStatus = [
  ValidatedBonusStatusEnums.UserType,
  ValidatedBonusStatusEnums.UserLevel,
  ValidatedBonusStatusEnums.Cancelled,
  ValidatedBonusStatusEnums.HasOtherActivated,
]

